import { render } from "./AdminManageGroomersComp.vue?vue&type=template&id=0d888c86&scoped=true"
import script from "./AdminManageGroomersComp.vue?vue&type=script&lang=js"
export * from "./AdminManageGroomersComp.vue?vue&type=script&lang=js"

import "./AdminManageGroomersComp.vue?vue&type=style&index=0&id=0d888c86&scoped=true&lang=css"

import exportComponent from "E:\\coding\\pharaoh_frog_barber\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d888c86"]])

export default __exports__